import React from "react";

interface Question {
  id: number;
  questionValue: string;
  answer: string;
}
interface Questionnaire {
  title: string;
  questions: Question[];
}
interface QuestionnairesCardListProps {
  questionnaires: Questionnaire[];
}

const QuestionnairesModal: React.FC<QuestionnairesCardListProps> = ({
  questionnaires,
}) => {
  return (
    <div>
      {questionnaires.map((questionnaire, index) => (
        <div key={index} className="mb-4">
          <h2 className="text-xl font-bold mb-4 mr-1 text-right">
            {questionnaire.title}
          </h2>
          <div className="border-b border-slate-300"></div>
          {questionnaire.questions.map((question) => (
            <div
              key={question.id}
              className="mt-4 justify-between flex w-full bg-zinc-200 p-1 rounded-lg bg-opacity-70"
            >
              <p className="text-base text-gray-600 mx-1 text-justify justify-center">
                {question.questionValue} :
              </p>
              <p className="text-base mx-1 text-gray-700 text-justify justify-center">
                {question.answer}
              </p>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default QuestionnairesModal;
